function LiveMap() {
    "use strict";
    this.Id = -1;
    this._type = 'LiveMap:www.veritracks.com';
    this.Version = 0;
    this.AgentName = '';
    this.EnrolleeId = -1;
    this.DeviceId = -1;
    this.DeviceSerialNumber = '';
    this.Latitude = -1;
    this.Longitude = -1;
    this.DeviceBatteryVoltage = 0;
    this.RiskLevelId = -1;
    this.EnrolleeName = '';
    this.PrimaryId = '';
    this.EnrolleeName = '';
    this.HasEventOpens = 0;
    this.OrganizationId = '';
    this.OpenEventPriority = 5;
    this.OpenEventId = -1;
    this.OpenEventViolationId = -1;
    this.ZoneEventIndicator = false;
    this.ScheduleEventIndicator = false;
    this.StrapTamperEventIndicator = false;
    this.AssociationEventIndicator = false;
}
if (typeof exports !== 'undefined') {
    module.exports = LiveMap;
}